/* src/app/core/components/header/language-switcher/language-switcher.component.scss */
li.nav-item > button.nav-link > i + span {
  font-weight: bolder;
}
/*# sourceMappingURL=language-switcher.component.css.map */
